import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { ViewMoreIcon } from "../../../assets/icons";
import useDeleteData from "../../../hooks/useDeleteData";
import { ScreenOpen } from "../../../utils/OtherFunctions";
import CreateOrEdit from "./from";
import ViewMOM from "./ViewMOM";

function ViewMore({ fetcher, data,satusData,id,getCompletion=()=>{} }) {
  const { handleDelete } = useDeleteData();
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);

  function EditScreen() {
    ScreenOpen({ link: "Minute-Of-Meeting", id: data.id });
    setShowMyModal(true);
  }

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl dropdown bg-white cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white text-left rounded-xl w-20 absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg"
                onClick={() => setShowFile(true)}
              >
                View
              </span>
              {GetAccess("information_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={EditScreen}
                >
                  Edit
                </span>
              )}
              {GetAccess("information_delete") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg"
                  onClick={() => {
                    handleDelete({
                      url: `/Minute-Of-Meeting/${data?.id}/`,
                      data: { data: { id: data?.id } },
                      id: data?.id,
                      value:"",
                      fetcher:()=>{fetcher();getCompletion()},
                    });
                  }}
                >
                  Delete
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateOrEdit
        onClose={handleOnClose}
        visible={showMyModal}
        data={data}
        refreshData={fetcher}
        satusData={satusData}
        getCompletion={getCompletion}
        id={id}
      />
      <ViewMOM data={data} onClose={handleClose} visible={showFile}/>
    </>
  );
}

export default ViewMore;
